import React from 'react';
const KIDS_6_7 = [{
  category: '- 19 Kg',
  size: '#00',
  level: '6'
}, {
  category: '- 23 Kg',
  size: '#00',
  level: '6'
}, {
  category: '- 27 Kg',
  size: '#00',
  level: '6'
}, {
  category: '+ 27 Kg',
  size: '#00',
  level: '6'
}];
const KIDS_8_9 = [{
  category: '- 21 Kg',
  size: '#00',
  level: '8'
}, {
  category: '- 25 Kg',
  size: '#00',
  level: '10'
}, {
  category: '- 30 Kg',
  size: '#00',
  level: '12'
}, {
  category: '+ 30 Kg',
  size: '#0',
  level: '14'
}];
const KIDS_10_11 = [{
  category: '- 30 Kg',
  size: '#00',
  level: '12'
}, {
  category: '- 35 Kg',
  size: '#0',
  level: '14'
}, {
  category: '- 40 Kg',
  size: '#0',
  level: '16'
}, {
  category: '+ 40 Kg',
  size: '#1',
  level: '12'
}];
type Row = {
  category: string;
  size: string;
  level: string;
};
/**
 * Kids Level tables (6-7, 8-9, 10-11 age brackets).
 * Owns its own data and table markup.
 */
export function KidsLevel() {
  return <div className="space-y-12" data-id="element-884">
      <Table title="Kids Level (6-7 years)" headerBg="bg-green-600" subtitle="SIZE & HIT LEVEL - DAEDO PSS (2014)" subtitleColor="text-green-100" rows={KIDS_6_7} data-id="element-885" />
      <Table title="Kids Level (8-9 years)" headerBg="bg-teal-600" subtitle="SIZE & HIT LEVEL - DAEDO PSS (2014)" subtitleColor="text-teal-100" rows={KIDS_8_9} data-id="element-886" />
      <Table title="Kids Level (10-11 years)" headerBg="bg-emerald-600" rows={KIDS_10_11} data-id="element-887" />
    </div>;
}
function Table({
  title,
  headerBg,
  subtitle,
  subtitleColor,
  rows
}: {
  title: string;
  headerBg: string;
  subtitle?: string;
  subtitleColor?: string;
  rows: Row[];
}) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-888">
      <div className={`${headerBg} px-6 py-4`} data-id="element-889">
        <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-890">
          {title}
        </h2>
        {subtitle && <p className={`${subtitleColor ?? 'text-white'} text-sm mt-1`} data-id="element-891">
            {subtitle}
          </p>}
      </div>
      <div data-id="element-892">
        <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-893">
          <tbody data-id="element-894">
            <tr className="border-b border-gray-200 bg-gray-50" data-id="element-895">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-896">
                Category
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 text-gray-600 font-medium" data-id="element-897">
                  {item.category}
                </td>)}
            </tr>
            <tr className="border-b border-gray-200" data-id="element-898">
              <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-899">
                Size
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-900">
                  {item.size}
                </td>)}
            </tr>
            <tr className="bg-gray-50" data-id="element-901">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-902">
                LEVEL
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-903">
                  {item.level}
                </td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}